import { StateCreator } from "zustand";
import { FetchSummaryVisitReportType } from "../../../domain/models/daily-visit-report/daily-visit-summary-report";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchSummaryVisitReport } from "../../../domain/useages/daily-visit-report/fetchSummaryVisitReport";
import { RemoteFetchSummaryVisitReport } from "../../../data/usecases/daily-visit-report/remote-fetch-summary-visit-report";
import Endpoints from "../../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchSummaryVisitReportInterface {
  FetchSummaryVisitReport: FetchSummaryVisitReportType;
  FetchSummaryVisitReportState: FetchState;
  fetchSummaryVisitReport: Function;
}

const initialStates = {
  FetchSummaryVisitReport: {} as FetchSummaryVisitReportType,
  FetchSummaryVisitReportState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchSummaryVisitReportSlice: StateCreator<
  FetchSummaryVisitReportInterface
> = (set) => ({
  ...initialStates,
  fetchSummaryVisitReport: async (params: FetchSummaryVisitReport.Params) => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchSummaryVisitReport = new RemoteFetchSummaryVisitReport(
      `${BASE_URL}${Endpoints.FETCH_SUMMARY_VISIT_REPORT}`,
      axiosHttpClient
    );

    set(() => ({ FetchSummaryVisitReportState: FetchState.LOADING }));
    let result = await remoteFetchSummaryVisitReport.fetch(params);
    return result;
  },
});
